import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FiCheck, FiX } from "react-icons/fi";
import "../css/paysuccess.css";

function PaymentResult() {
  const [params] = useSearchParams();
  const success = params.get("state") === "success";
  return <main className="success-pay" aria-labelledby="payment-result-title">
    <section className="success-pay__content">
      <div className="success-pay__mark" aria-hidden="true">{success ? <FiCheck /> : <FiX />}</div>
      <p className="success-pay__eyebrow">{success ? "Payment successful" : "Payment cancelled"}</p>
      <h1 id="payment-result-title">{success ? "Thank you for your order." : "Your order was not completed."}</h1>
      <p className="success-pay__message">{success ? "Your payment was accepted. A confirmation will be sent to the email used at checkout." : "No completed payment was recorded. You can return to your bag and try again when ready."}</p>
      <div className="success-pay__actions"><Link to={success ? "/shop" : "/cartpage"}>{success ? "Continue shopping" : "Return to bag"}</Link><Link to="/contact">Contact customer care</Link></div>
    </section>
  </main>;
}

export default PaymentResult;
